import $ from "jquery";
import { FireComponent } from "@component";

export class Sharethis extends FireComponent {
  constructor(id) {
    super(id);

    this.url = location.href;
    this.message = this.$component.attr("data-share-message");
    this.image = `${location.origin}${this.$component.attr(
      "data-share-image"
    )}`;

    this.$facebook = this.$component.find("[data-facebook]");
    this.$twitter = this.$component.find("[data-twitter]");
    this.$linkedin = this.$component.find("[data-linkedin]");

    this.shareObjects = [
      { name: "facebook", element: this.$facebook },
      { name: "twitter", element: this.$twitter },
      { name: "linkedin", element: this.$linkedin },
    ];
  }

  initClickHandlers() {
    this.shareObjects.forEach((object) => {
      object.element.on("click", () => {
        switch (object.name) {
          case "facebook":
            document.open(
              `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                this.url
              )}`,
              "",
              "width=626,height=436"
            );
            break;

          case "twitter":
            document.open(
              `https://twitter.com/share?url=/&text=${this.message} : ${this.url}`,
              "",
              "width=626,height=300"
            );
            break;

          case "linkedin":
            document.open(
              `https://www.linkedin.com/shareArticle?mini=true&url=${this.url}&title=${this.message}&source=golden-reserve`,
              "",
              "width=626,height=300"
            );
            break;
        }
      });
    });
  }

  init() {
    if (!this.componentExists) return;

    this.initClickHandlers();
  }
}
